<button [disabled]="isDisabled()" (click)="onClick($event)"
        *ngIf="isVisibale() === true"
        class="wep-ag-grid-cell-renderer-action__button">
    <i class="{{getClass()}}"></i>
    <span class="wep-ag-grid-cell-renderer-action__text" *ngIf="getDisplayText()">{{getDisplayText()}}</span>
</button>
